var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 -0.5 24 24",
    id: "meteor-icon-kit__solid-star",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.7998 22.3168C5.78902 22.7622 4.60854 22.3039 4.16313 21.2931C4.02364 20.9766 3.96864 20.6293 4.00348 20.2852L4.57592 14.6314L0.789612 10.3939C0.0536467 9.5702 0.124744 8.3059 0.948413 7.56994C1.20635 7.33946 1.51965 7.17983 1.85771 7.10662L7.41165 5.90394L10.2717 0.99348C10.8277 0.03901 12.0521 -0.284071 13.0066 0.27186C13.3054 0.44595 13.5541 0.69459 13.7282 0.99348L16.5883 5.90394L22.1422 7.10662C23.2217 7.3404 23.9074 8.40505 23.6736 9.4846C23.6004 9.8227 23.4408 10.136 23.2103 10.3939L19.424 14.6314L19.9964 20.2852C20.1077 21.3841 19.307 22.3652 18.2081 22.4765C17.8639 22.5113 17.5166 22.4563 17.2001 22.3168L12 20.0253L6.7998 22.3168z",
    fill: "#f8d448"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.e808ec19aa8c33f2c728aa32243b527f.svg";
export { ForwardRef as ReactComponent };